import Cookies from 'js-cookie';
const SITE_NAME = window.siteConfig().siteName;
const NAME = `${SITE_NAME}_show_country_switch_modal`;

export const CountrySelectorCookie = {
    add: () => {
        Cookies.set(NAME, true);
    },

    get: () => {
        return Cookies.get(NAME) || false;
    },
};
